
export default "/assets/list-filter.6f255b48.svg"